import httpAdminClient from '@/plugins/httpAdminClient';

export default {
  dashboard() {
    return httpAdminClient.get('admin/meeting/dashboard');
  },
};



// WEBPACK FOOTER //
// ./src/apiSet/adminApis/meeting/homeApis.js